import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full" }
const _hoisted_2 = { class: "flex items-center flex-grow-0 border-b shadow bg-primary-dark" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "pl-8",
  "data-testid": "back-to-student-dashboard"
}, "←", -1)
const _hoisted_4 = { class: "flex-shrink-0 w-10 h-10 ml-6 overflow-hidden border rounded-full" }
const _hoisted_5 = { class: "ml-6 w-72" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: _ctx.Routes.STUDENT_DASHBOARD }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("img", {
          src: _ctx.student.photoUrl,
          alt: _ctx.student.firstName
        }, null, 8, ["src", "alt"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.student.firstName) + " " + _toDisplayString(_ctx.student.lastName), 1),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.courseLabel), 1)
      ]),
      _createVNode(_component_router_link, {
        to: {
          name: _ctx.Routes.STUDENT_PROGRESS,
          params: { id: String(_ctx.student.id) }
        },
        tag: "div"
      }, {
        default: _withCtx(({ isActive }) => [
          _createVNode("div", {
            class: ["p-4 text-sm border-b-4 border-transparent", { 'border-highlight': isActive }],
            "data-testid": "progress-link"
          }, " Progress ", 2)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: {
          name: _ctx.Routes.STUDENT_EVENTS,
          params: { id: String(_ctx.student.id) }
        },
        tag: "div"
      }, {
        default: _withCtx(({ isActive }) => [
          _createVNode("div", {
            class: ["block w-full p-4 text-sm border-b-4 border-transparent", { 'border-highlight': isActive }],
            "data-testid": "events-link"
          }, " Grading ", 2)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: {
          name: _ctx.Routes.STUDENT_PROJECTIONS,
          params: { id: String(_ctx.student.id) }
        },
        tag: "div"
      }, {
        default: _withCtx(({ isActive }) => [
          _createVNode("div", {
            class: ["block w-full p-4 text-sm border-b-4 border-transparent", { 'border-highlight': isActive }],
            "data-testid": "projections-link"
          }, " Projections ", 2)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: {
          name: _ctx.Routes.STUDENT_SKILL_GRAPH,
          params: { id: String(_ctx.student.id) }
        },
        tag: "div"
      }, {
        default: _withCtx(({ isActive }) => [
          _createVNode("div", {
            class: ["block w-full p-4 text-sm border-b-4 border-transparent", { 'border-highlight': isActive }],
            "data-testid": "skillgraph-link"
          }, " Skill Graph ", 2)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_router_view)
  ]))
}